// extracted by mini-css-extract-plugin
export default {"container":"EventsSection_container__O0sna","list":"EventsSection_list__FEFnP","header":"EventsSection_header__1Pamd","viewAll":"EventsSection_viewAll__rDsyL"};